export default "__VITE_ASSET__CsN6Fm6y__"